import { Navigate, Route, Routes as RouterRoutes } from "react-router-dom"
import React from "react"
import { protectedRoutes, publicRoutes } from "configs/RoutesConfig"
import { AUTHENTICATED_ENTRY } from "configs/AppConfig"

import PublicRoute from "./PublicRoute"
import ProtectedRoute from "./ProtectedRoute"
import AppRoute from "./AppRoute"
import { useGet } from "utils/network"
import { USER_TYPE } from "constants/AuthConstant"

const Routes = () => {
  // get the profile
  const { data: profile } = useGet({
    path:
      localStorage.getItem(USER_TYPE) === "doctor"
        ? "doctorOffice/profil"
        : "user/profil",
    authorization: true,
  })

  // Define a function to check if the user has access to a specific controller
  const hasAccess = (controller) => {
    if (!profile || !profile.privileges) return false
    return profile.privileges?.some(
      (privilege) =>
        privilege.controller === controller &&
        (privilege.reader || privilege.editor || privilege.delete)
    )
  }

  return (
    <RouterRoutes>
      <Route element={<ProtectedRoute />} path="/">
        <Route
          element={<Navigate replace to={AUTHENTICATED_ENTRY} />}
          path="/"
        />
        {protectedRoutes.map((route, index) => {
          // Check if the user has access to the controller and permission for this route
          const canAccess =
            localStorage.getItem(USER_TYPE) === "doctor" ||
            hasAccess(route.controller) ||
            route.accessUser
          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                canAccess ? (
                  <AppRoute
                    component={route.component}
                    routeKey={route.key}
                    {...route.meta}
                  />
                ) : null // Do not redirect immediately, just don't render the route
              }
            />
          )
        })}

        <Route element={<Navigate replace to="/" />} path="*" />
      </Route>
      <Route element={<PublicRoute />} path="/">
        {publicRoutes.map((route) => {
          return (
            <Route
              element={
                <AppRoute
                  component={route.component}
                  routeKey={route.key}
                  {...route.meta}
                />
              }
              key={route.path}
              path={route.path}
            />
          )
        })}
      </Route>
    </RouterRoutes>
  )
}

export default Routes
